const ta = {
  nav: {
    login: 'உள்நுழைவு',
    bookNow: 'இப்போது புக் செய்யவும்',
    dashboard: 'டாஷ்போர்டு',
    back: 'பின்',
    home: 'முகப்பு',
  },
  landing: {
    heroTitle1: 'வான்வழிப் பயணங்கள்,',
    heroTitle2: 'இப்போது எளிது',
    heroSubtitle: 'இந்தியாவின் முன்னணி ஹெலிகாப்டர் சார்ட்டர் தளம். சரிபார்க்கப்பட்ட ஆபரேட்டர்களுடன் இணைந்து, உடனடியாக விமானங்களை புக் செய்யுங்கள்.',
    bookYourFlight: 'உங்கள் விமானத்தை புக் செய்யவும்',
    becomeOperator: 'ஆபரேட்டராகுங்கள்',
    whyChoose: 'ஏன் AirYatra?',
    verifiedOperators: 'சரிபார்க்கப்பட்ட ஆபரேட்டர்கள்',
    verifiedOperatorsDesc: 'அனைத்து ஆபரேட்டர்களும் AOC சான்றிதழ்கள், காப்பீடு மற்றும் பாதுகாப்பு இணக்கத்துடன் முழுமையாக சரிபார்க்கப்பட்டுள்ளனர்.',
    bestPrices: 'சிறந்த விலைகள்',
    bestPricesDesc: 'AI-இயங்கும் விலை பரிந்துரைகள் பல ஆபரேட்டர்களிடமிருந்து போட்டி விலைகளை உறுதி செய்கின்றன.',
    seamlessBooking: 'எளிதான புக்கிங்',
    seamlessBookingDesc: 'விலை கோரிக்கை முதல் டிஜிட்டல் டிக்கெட் வரை, உங்கள் முழு பயணத்தையும் ஒரே தளத்தில் நிர்வகிக்கவும்.',
    flightsCompleted: 'நிறைவு பெற்ற விமானங்கள்',
    verifiedOperatorsStat: 'சரிபார்க்கப்பட்ட ஆபரேட்டர்கள்',
    safetyRecord: 'பாதுகாப்பு பதிவு',
    customerRating: 'வாடிக்கையாளர் மதிப்பீடு',
    premiumServices: 'பிரீமியம் சேவைகள்',
    elevateExperience: 'உங்கள் அனுபவத்தை உயர்த்துங்கள்',
    premiumSubtitle: 'எங்கள் பிரீமியம் உறுப்பினர் மற்றும் கார்ப்பரேட் பயண தீர்வுகளுடன் சிறப்பு பலன்களைப் பெறுங்கள்',
    blackDesc: '20% வரை தள்ளுபடி, முன்னுரிமை புக்கிங், பிரத்யேக பைலட் மற்றும் லவுஞ்ச் அணுகலுடன் பிரீமியம் உறுப்பினர்.',
    priorityQueue: 'முன்னுரிமை புக்கிங் வரிசை',
    dedicatedManager: 'பிரத்யேக உறவு மேலாளர்',
    freeCancellation: 'இலவச ரத்து',
    exploreMembership: 'உறுப்பினர் விவரம்',
    corporateConsole: 'கார்ப்பரேட் கன்சோல்',
    corporateDesc: 'ஒப்புதல் பணிப்பாய்வுகள், பட்ஜெட்கள் மற்றும் ஒருங்கிணைந்த பில்லிங்குடன் நிறுவனங்களுக்கான மையப்படுத்தப்பட்ட பயண மேலாண்மை.',
    employeeManagement: 'ஊழியர் மேலாண்மை',
    budgetControls: 'பட்ஜெட் கட்டுப்பாடுகள்',
    travelAnalytics: 'பயண பகுப்பாய்வு',
    corporateRegistration: 'கார்ப்பரேட் பதிவு',
    documentVault: 'ஆவண வால்ட்',
    vaultDesc: 'DGCA ஆவணங்கள், காப்பீடு, உரிமங்களுக்கான பாதுகாப்பான என்க்ரிப்டட் சேமிப்பு - காலாவதி எச்சரிக்கைகள் மற்றும் பதிப்பு கட்டுப்பாட்டுடன்.',
    encryption: 'AES-256 என்க்ரிப்ஷன்',
    expiryReminders: 'காலாவதி நினைவூட்டல்கள்',
    secureSharing: 'பாதுகாப்பான பகிர்வு',
    openVault: 'வால்ட் திறக்கவும்',
    loginToAccess: 'அணுக உள்நுழையவும்',
    readyTakeOff: 'பறக்கத் தயாரா?',
    ctaSubtitle: 'இன்றே உங்கள் ஹெலிகாப்டர் சார்ட்டரை புக் செய்து விமான சிறப்பை அனுபவியுங்கள்.',
    startBooking: 'புக்கிங் தொடங்கவும்',
    footerText: '© 2025 AirYatra. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை. இந்தியாவின் முன்னணி ஹெலிகாப்டர் சார்ட்டர் தளம்.',
  },
  booking: {
    title: 'உங்கள் விமானத்தை புக் செய்யவும்',
    subtitle: 'AirYatra - பிரீமியம் ஏர் மொபிலிட்டி சேவைகள்',
    previous: 'முந்தையது',
    next: 'அடுத்து',
    loginPrompt: 'புக்கிங் விசாரணைக்கு உள்நுழையவும்',
    loginBtn: 'உள்நுழைவு',
    steps: {
      passengers: 'பயணிகள்',
      booking_type: 'புக்கிங் வகை',
      route: 'வழி',
      price_inquiry: 'விலை',
    },
  },
  bookingForm: {
    selectAircraftType: 'விமான வகையைத் தேர்ந்தெடுக்கவும்',
    maxPassengers: 'அதிகபட்சம் {{count}} பயணிகள்',
    adultPassengers: 'வயது வந்த பயணிகள்',
    male: 'ஆண்',
    female: 'பெண்',
    totalAdults: 'மொத்த பெரியவர்கள்',
    children: 'குழந்தைகள் (4 வயது வரை)',
    childrenFree: 'இலவசம் - அதிகபட்சம் 2 குழந்தைகள்',
    flightType: 'விமான வகை',
    selectOption: '-- தேர்ந்தெடுக்கவும் --',
    bookingFor: 'யாருக்காக புக்கிங்',
    bookingPurpose: 'புக்கிங் நோக்கம்',
    selected: 'தேர்ந்தெடுக்கப்பட்டது',
    specifyPurpose: 'நோக்கத்தைக் குறிப்பிடவும்',
    pickupLocation: 'பிக்அப் இடம்',
    selectPickupPoint: 'பிக்அப் புள்ளியைத் தேர்ந்தெடுக்கவும்',
    dropLocation: 'டிராப் இடம்',
    selectDropPoint: 'டிராப் புள்ளியைத் தேர்ந்தெடுக்கவும்',
    estimatedDistance: 'மதிப்பிடப்பட்ட தூரம்',
    villageDocsTitle: 'கிராம லேண்டிங் - ஆவணங்கள் தேவை',
    villageDocsDesc: 'கிராமம்/தனியார் நிலத்தில் இறங்குவதற்கு, அதிகாரிகளிடமிருந்து பின்வரும் ஆவணங்களைப் பெற வேண்டும்:',
    villageDocsNote: 'புக்கிங் உறுதிசெய்யப்பட்ட பிறகு, இந்த ஆவணங்களை பதிவேற்ற வேண்டும். Admin/Operator சரிபார்த்த பின்னரே பைலட் பறப்பார்.',
    departureDate: 'புறப்படும் தேதி',
    pickupTime: 'பிக்அப் நேரம்',
    additionalOptions: 'கூடுதல் விருப்பங்கள் (விருப்பம்)',
    waitingTime: 'காத்திருப்பு நேரம் (நிமிடங்கள்)',
    waitingTimeNote: 'முதல் 30 நிமிடங்கள் இலவசம், பின்னர் கட்டணம்',
    nightHalts: 'இரவு தங்குதல்',
    nightHaltsNote: 'குழு தங்குமிட கட்டணம் உட்பட',
    bookingSummary: 'புக்கிங் சுருக்கம்',
    aircraftTypeLabel: 'விமான வகை:',
    totalPassengersLabel: 'மொத்த பயணிகள்:',
    adults: 'பெரியவர்கள்',
    childrenLabel: 'குழந்தைகள்',
    flightTypeLabel: 'விமான வகை:',
    pickupLabel: 'பிக்அப்:',
    dropLabel: 'டிராப்:',
    distanceLabel: 'தூரம்:',
    dateTimeLabel: 'தேதி & நேரம்:',
    at: 'மணிக்கு',
    villageApprovalTitle: 'கிராம லேண்டிங் - நிர்வாக ஒப்புதல் தேவை',
    villageApprovalDesc: 'உங்கள் விசாரணை நிர்வாக ஒப்புதலுக்கு சமர்ப்பிக்கப்படும். ஒப்புதலுக்குப் பிறகு பணம் செலுத்தலாம்.',
    priceBreakdown: 'விலை விவரம்',
    baseFlightCost: 'அடிப்படை விமான செலவு',
    flightCost: 'விமான செலவு',
    positioningCost: 'பொசிஷனிங் செலவு (டெட்-லெக்)',
    roundTripDiscount: 'இரு வழி பயண தள்ளுபடி',
    operatorGrossCost: 'ஆபரேட்டர் மொத்த செலவு',
    additionalCharges: 'கூடுதல் கட்டணங்கள்',
    waitingGroundHolding: 'காத்திருப்பு / கிரவுண்ட் ஹோல்டிங்',
    nightHalt: 'இரவு தங்குதல் ({{count}} இரவுகள்)',
    crewAccommodation: 'குழு தங்குமிடம் & உணவு',
    fuelSurcharge: 'எரிபொருள் கூடுதல் கட்டணம்',
    platformFees: 'பிளாட்ஃபார்ம் கட்டணங்கள்',
    convenienceFee: 'வசதி கட்டணம்',
    insurance: 'காப்பீடு',
    peakSurge: 'உச்ச சீசன் உயர்வு',
    platformCommission: 'பிளாட்ஃபார்ம் கமிஷன்',
    included: 'சேர்க்கப்பட்டுள்ளது',
    helipadCharges: 'ஹெலிபேட் லேண்டிங் கட்டணங்கள்',
    totalLandingCharges: 'மொத்த லேண்டிங் கட்டணங்கள்',
    taxableAmount: 'வரிக்குட்பட்ட தொகை',
    totalGst: 'மொத்த GST',
    grandTotal: 'மொத்த தொகை',
    inclusiveTaxes: 'அனைத்து வரிகளும் உட்பட',
    operatorReceives: 'ஆபரேட்டர் பெறுவார்',
    specialRequirements: 'சிறப்பு தேவைகள் (விருப்பம்)',
    specialRequirementsPlaceholder: 'ஏதேனும் சிறப்பு கோரிக்கைகள் அல்லது தேவைகள்...',
    submitting: 'சமர்ப்பிக்கிறது...',
    submitApproval: 'ஒப்புதலுக்கு சமர்ப்பிக்கவும்',
    generateInquiry: 'விசாரணை அனுப்பவும்',
    approvalNote: 'கிராம லேண்டிங்கிற்கு நிர்வாக ஒப்புதல் தேவை.',
    inquiryNote: 'விசாரணைக்குப் பிறகு, ஆபரேட்டர்கள் உங்களுக்கு விலைகளை அனுப்புவார்கள்.',
    formRestored: 'படிவத் தரவு மீட்டமைக்கப்பட்டது!',
    selectAircraftError: 'விமான வகையைத் தேர்ந்தெடுக்கவும்',
    minAdultError: 'குறைந்தது 1 வயது வந்த பயணி தேவை',
    maxChildrenError: 'அதிகபட்சம் 2 குழந்தைகள் மட்டுமே',
    selectFlightTypeError: 'விமான வகையைத் தேர்ந்தெடுக்கவும்',
    selectBookingForError: 'யாருக்காக புக்கிங் என்பதைத் தேர்ந்தெடுக்கவும்',
    selectPurposeError: 'புக்கிங் நோக்கத்தைத் தேர்ந்தெடுக்கவும்',
    selectPickupError: 'பிக்அப் இடத்தைத் தேர்ந்தெடுக்கவும்',
    selectDropError: 'டிராப் இடத்தைத் தேர்ந்தெடுக்கவும்',
    selectDateError: 'புறப்படும் தேதியைத் தேர்ந்தெடுக்கவும்',
    selectTimeError: 'பிக்அப் நேரத்தைத் தேர்ந்தெடுக்கவும்',
    priceWaitError: 'விலை கணக்கிடப்படவில்லை! காத்திருக்கவும்',
    inquirySubmitted: 'விசாரணை சமர்ப்பிக்கப்பட்டது! ஆபரேட்டர்கள் விரைவில் பதிலளிப்பார்கள்',
    noteVillageApproval: 'கிராம லேண்டிங்கிற்கு நிர்வாக ஒப்புதல் தேவை',
    notePriceEngine: 'ஏவியேஷன்-கிரேட் பிரைசிங் இன்ஜின் மூலம் கணக்கிடப்பட்டது',
    noteFinalPrice: 'இறுதி விலை ஆபரேட்டரால் உறுதிப்படுத்தப்படும்',
    docCollectorNoc: 'கலெக்டர் NOC',
    docFireDept: 'தீயணைப்புத் துறை ஒப்புகை',
    docPoliceStation: 'உள்ளூர் காவல் நிலைய ஒப்புகை',
    docSpDcp: 'SP/DCP ஒப்புகை',
  },
  options: {
    helicopter: 'ஹெலிகாப்டர்',
    chartered_plane: 'சார்ட்டர்டு விமானம்',
    one_hour: '1 மணி நேர பறப்பு',
    two_hour: '2 மணி நேர பறப்பு',
    half_day: 'அரை நாள்',
    full_day: 'முழு நாள்',
    multi_city: 'பல நகரங்கள்',
    point_to_point: 'புள்ளிக்கு புள்ளி',
    self: 'எனக்காக',
    friend_family: 'நண்பர்கள் & குடும்பம்',
    company: 'நிறுவனம் / கார்ப்பரேட்',
    political: 'அரசியல் / VIP',
    other: 'மற்றவை',
    wedding: 'திருமணம்',
    temple_yatra: 'கோயில் யாத்திரை',
    company_tour: 'கார்ப்பரேட் சுற்றுலா',
    election_tour: 'தேர்தல் பிரச்சாரம்',
    medical_emergency: 'மருத்துவ அவசரம்',
    film_shooting: 'திரைப்பட படப்பிடிப்பு',
    general_tour: 'பொது சுற்றுலா',
    pilgrimage: 'புனித யாத்திரை',
    business: 'வணிக சந்திப்பு',
  },
};

export default ta;
